import React, { Component, Fragment } from 'react';
import { Main, Filter } from 'Containers/';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import moment from 'moment';

import { TitledCard } from 'Components/';
import {
  RecipePreparationFiltersEnum as FilterFields,
  RecipePreparationTableFieldEnum as RecPrepFields,
} from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import * as SiteActions from 'State/sites/actions';
import * as CommonStateSelectors from 'State/selectors';
import { RECIPE_PREPARATION_TABLE_FORM_NAME } from 'Common/FormEnum';
import { errorToast } from 'Common/ToastHelper';
import { withRecipesSubscription } from 'Common/Components/RecipeSearch';
import { withReportSubscription } from 'State/report/withReportSubscription';

import * as RecPrepSelectors from './state/selectors';
import * as RecPrepActions from './state/actions';
import { RecipePreparationFilters } from './components/RecipePreparationFilters';
import { RecipeTableForm } from './components/RecipeTableForm';
import { getFiltersForTab, TABS, mapFormToParam } from './helpers';

const now = moment().format(DATE_FORMAT_FOR_UI);

class RecipePreparation extends Component {
  state = {};

  get mainProps() {
    const { submit, reportFetching, hasSelected } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            loading: reportFetching,
            disabled: !hasSelected || reportFetching,
            content: 'View Reports',
            onClick: () => submit(RECIPE_PREPARATION_TABLE_FORM_NAME),
          },
        ],
        shown: true,
      },
    };
  }

  componentDidUpdate(prevProps) {
    const { resetError } = this.props;
    errorToast(this.props, prevProps, 'error', resetError);
  }

  componentDidMount() {
    const { getCycleMenus, getSites } = this.props;
    getCycleMenus();
    getSites();
  }

  get tabFilters() {
    const { filters, tabIndex } = this.props;
    return getFiltersForTab(tabIndex, filters);
  }

  searchRecipes = () => {
    const { searchPrepRecipes } = this.props;
    searchPrepRecipes(this.tabFilters);
  };

  onSubmit = values => {
    const { getReport, filters } = this.props;
    const recipes = values[RecPrepFields.Recipes] || [];
    const orderBy = filters[FilterFields.OrderBy];
    const data = mapFormToParam(recipes, orderBy);
    getReport('reports/RecipePreparationReport', data);
  };

  render() {
    const { tabIndex, loadingRecipes, searchResults } = this.props;
    return (
      <Fragment>
        <Filter title="Recipe Preparation" />
        <Main {...this.mainProps}>
          <TitledCard title="Filters">
            <RecipePreparationFilters
              activeIndex={tabIndex}
              initialValues={{
                [FilterFields.GroupId]: 0,
                [FilterFields.Status]: 1,
                [FilterFields.Tab]: TABS.RECIPE_GROUP,
                [FilterFields.Date]: now,
                [FilterFields.OrderBy]: 'Name',
              }}
              onSubmit={this.searchRecipes}
              {...this.props}
            />
          </TitledCard>
          <TitledCard title="Recipes">
            <RecipeTableForm
              initialValues={{
                [RecPrepFields.Recipes]: searchResults,
              }}
              loading={loadingRecipes}
              onSubmit={this.onSubmit}
            />
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {
  getCycleMenus: RecPrepActions.getCycleMenus,
  resetError: RecPrepActions.resetError,
  getSites: SiteActions.getSites,
  submit,
};

const mapStateToProps = state => ({
  siteOptions: CommonStateSelectors.getSiteOptions(state),
  cycleMenuOptions: RecPrepSelectors.getCycleMenuOptions(state),
  filters: RecPrepSelectors.getFilterValues(state),
  tabIndex: RecPrepSelectors.getTabIndex(state),
  error: RecPrepSelectors.getError(state),
  hasSelected: RecPrepSelectors.getHasSelected(state),
});

RecipePreparation = withRecipesSubscription(RecipePreparation);
RecipePreparation = withReportSubscription(RecipePreparation);

RecipePreparation = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecipePreparation);

export { RecipePreparation };



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/RecipePreparation.js